import { state, getters, mutations, actions } from './store';

export const name = '$_operationsFormManagement';
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
